import React, { useState, useEffect, useCallback } from 'react'
import {
  ReactFlow,
  Background,
  useNodesState,
  useEdgesState,
  Handle,
  Position,
  addEdge,
  MiniMap,
  Controls,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import useAxios from '../../../lib/auth/useAxios'
import { Button, Modal, Menu, Table, Segment } from 'semantic-ui-react'
import MickeyForm from '../../../components/Forms/MickeyForm'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import OrderCargoDetailsRow from '../../buyer/Orders/OrderCargoDetailsRow'
import QueryDashboard from './QueryDashboard'
import { useSelector } from 'react-redux'

const AdminTenant = (props) => {
  const { openAddModal, setOpenAddModal } = props
  const axios = useAxios()
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(false)
  const [emailInjestions, setEmailInjestions] = useState({
    nodes: [],
    edges: [],
  })
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })

  return (
    <div
      style={{
        width: '100%',
        height: '900px',
        marginTop: '30px',
        padding: '0 20px',
      }}
    >
      <MickeyForm
        formName={'TenantForm'}
        model={'Tenant'}
        instanceId={tenant?.id}
        url={'/main/tenants/'}
        handleForm={() => {
          // setAddNewLocationModal(false)
        }}
      />
      {/* <QueryDashboard /> */}
    </div>
  )
}

export default AdminTenant
